// Animation configs + equipment photo URLs for the Studio Setup Guide.
export const container = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.05 } },
};

export const itemAnim = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.3 } },
};

// Unsplash photography equipment photos — each verified to match the
// specific equipment described on its card (Apr 23, 2026).
// Four cards (Speedlight, LED Panel, Beauty Dish, Reflector) use custom
// AI-generated photorealistic product shots served from /public/studio/.
export const PHOTOS = {
  // Hero: studio floor with Godox QT-400II strobes, light stands, umbrella,
  // seamless white backdrop.
  hero:
    "https://images.unsplash.com/photo-1697920575169-b038b77ea816?w=1200&q=80",
  // AI-generated Godox TT685II hotshoe speedlight on dark studio surface.
  speedlight: "/studio/speedlight.png",
  // Professional AC-powered Godox QT-400II monolights on light stands.
  strobe:
    "https://images.unsplash.com/photo-1697920575169-b038b77ea816?w=800&q=80",
  // AI-generated Aputure flat LED panel on a light stand.
  led: "/studio/led.png",
  // Two studio softboxes with SL-150W flash heads — textbook softbox shot.
  softbox:
    "https://images.unsplash.com/photo-1557860854-c7ed6b193822?w=800&q=80",
  // Photography umbrella/parabolic modifier mounted on Godox SL60BI LED.
  umbrella:
    "https://images.unsplash.com/photo-1745848038063-bbb6fc8c8867?w=800&q=80",
  // AI-generated Bowens 55° silver beauty dish on a studio strobe.
  beauty: "/studio/beauty.png",
  // AI-generated 5-in-1 collapsible reflector disc held by a photographer.
  reflector: "/studio/reflector.png",
  // Rolled seamless paper backdrops lined up in studio — exact match.
  paper:
    "https://images.unsplash.com/photo-1736580602099-c9367f32feaa?w=800&q=80",
  // Large white seamless / muslin backdrop supported by stands, with
  // additional rolled backdrops — perfect muslin/canvas reference.
  muslin:
    "https://images.unsplash.com/photo-1736580602053-b88e8220095d?w=800&q=80",
  // Chroma-green screen backdrop with tracking markers — exact match.
  greenscreen:
    "https://images.unsplash.com/photo-1612709375837-bf2f53f0c11c?w=800&q=80",
  // Bright modern studio with round softbox and backdrop roll — good
  // reference for a compact / collapsible backdrop setup in a small space.
  collapsible:
    "https://images.unsplash.com/photo-1736580602642-4b9fcec9163d?w=800&q=80",
};
